var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOinqtip = function SvgOinqtip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Oinq Tip Icon",
    viewBox: "0 0 194.814 171.506"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "oinqtip_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h124.712v126.375H0z",
    "data-name": "Rectangle 319"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "oinqtip_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 5.705h5.622S28.315-.783 36.496.605a38.6 38.6 0 0 0-7.588-.6c-6.347 0-16.372 1.018-28.909 5.706",
    "data-name": "Path 1047"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "oinqtip_svg__c",
    x1: -1.135,
    x2: -1.125,
    y1: 17.808,
    y2: 17.808,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#242929"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#242929"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.954,
    height: 91.954,
    fill: "#67e29c",
    "data-name": "Rectangle 377",
    rx: 19,
    transform: "rotate(23 13.667 130.022)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1c2451",
    d: "m14.771 38.307-2.11 8.229 8.229-2.111-7.311 4.326 7.311 4.326-8.229-2.111 2.111 8.229-4.326-7.311-4.328 7.313 2.111-8.229L0 53.078l7.311-4.326L0 44.425l8.229 2.111-2.111-8.229 4.326 7.311Z",
    "data-name": "Polygon 58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m59.535 150.617-2.11 8.229 8.229-2.111-7.311 4.326 7.311 4.326-8.229-2.111 2.111 8.229-4.326-7.311-4.328 7.313 2.111-8.229-8.229 2.11 7.311-4.326-7.311-4.327 8.229 2.111-2.111-8.229 4.326 7.311Z",
    "data-name": "Polygon 59"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 91.954,
    height: 91.954,
    fill: "#c9ffdd",
    "data-name": "Rectangle 378",
    rx: 25,
    transform: "rotate(-12.04 306.058 -135.826)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 677"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 455",
    transform: "translate(85.426)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80.077,
    height: 80.077,
    fill: "#d1d1d1",
    "data-name": "Rectangle 286",
    rx: 16,
    transform: "rotate(30 -56.915 95.328)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#d1d1d1",
    "data-name": "@?",
    fontFamily: "Metropolis-ExtraBold, Metropolis",
    fontSize: 16,
    fontWeight: 800,
    letterSpacing: "-.04em",
    transform: "translate(79.645 93.342)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -10,
    y: 0
  }, "@?")), /*#__PURE__*/React.createElement("path", {
    fill: "#4db96e",
    d: "m30.848 0-2.11 8.229 8.229-2.111-7.311 4.326 7.311 4.326-8.229-2.111 2.111 8.229-4.326-7.311-4.328 7.313 2.111-8.229-8.229 2.11 7.311-4.326-7.311-4.327 8.229 2.111L22.195 0l4.326 7.311Z",
    "data-name": "Polygon 53"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 533"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 528"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#oinqtip_svg__a)",
    "data-name": "Group 527",
    transform: "translate(52.029 12.566)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4db96e",
    d: "M115.437 31.654c4.829-6.554 11.6-24.309-.731-24.082-10.491.19-20.562 5.483-23.735 7.29-12.768-3.754-25.222-3.389-26.714-3.1a68.1 68.1 0 0 0-26.5 3.4C35.312 13.7 24.645 7.785 13.514 7.581c-12.656-.239-5.177 18.481-.345 24.57a54 54 0 0 0-3.87 5.63c-17.832 29.744-5.06 73.591 31.407 85.288 14.5 4.646 60.914 8.773 76.727-19.984 12.22-22.225 7.318-55.983-2-71.431",
    "data-name": "Path 1036"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b9f60",
    d: "M115.436 31.654c4.386-5.969 10.4-21.2 2.138-23.731 6.269 4.774-1.075 18.643-5.414 16.844-3.674-1.283-12.165-7.23-19.048-11.069-.881.453-1.608.855-2.135 1.159h-.037c7.2 4.273 18.471 10.89 20.883 17.627 9.014 25.168 9.738 47.985-5 69.855-9.347 13.858-28.545 18.094-43.061 19.268a81.8 81.8 0 0 1-35.377-4.189 55.8 55.8 0 0 0 12.321 5.651c14.5 4.646 60.914 8.773 76.727-19.984 12.22-22.225 7.318-55.983-2-71.431",
    "data-name": "Path 1037"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6fc282",
    d: "M44.021 15.779a85.3 85.3 0 0 0-18.812 9.383c-7.944 5.305-16.147 13.093-18.912 23.49-5.008 18.749 2.673 45.715 19.692 57.529s54.714 9.756 67.1-2.424c15.828-15.565 7.548-28.951-3.458-29.514 0 0-14.231-6.214-19.571-.037-2.672 3.856-14.691 4.624-15.693-1.539-2.668-3.593-7.925-1.053-20.028 2.694-5.37 1.649-15.605-12.608-3.177-22.477 15.459-12.275 60.315-10.115 69.844 7.432 7.2 13.24 10.685-28.7-5.341-36.92s-34.617-10.184-51.644-7.617",
    "data-name": "Path 1038"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6fc282",
    d: "M99.445 20.717s10.272 6.945 11.785 9.665c2.413-.3 6.039-10.875 5.436-14.5s-10.868-2.705-17.221 4.836",
    "data-name": "Path 1039"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b9f60",
    d: "M116.665 15.892a1.99 1.99 0 0 0-.928-1.349c-.344 3.677-1.155 9.387-4.752 10.041-3.381.753-7.845-2.672-10.8-4.69-.252.271-.5.545-.731.833 0 0 10.272 6.945 11.785 9.665 2.405-.3 6.031-10.875 5.428-14.5",
    "data-name": "Path 1040"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b9f60",
    d: "M51.163 31.283a1 1 0 0 1-.536-.144 2.1 2.1 0 0 1-.551-.446c-7.592-8.387-11.552-4.074-11.715-3.89a.48.48 0 0 1-.281.153.8.8 0 0 1-.382-.039 1.95 1.95 0 0 1-.827-.6 2.4 2.4 0 0 1-.508-.968.87.87 0 0 1 .109-.765c.056-.056 5.177-5.643 14.582 4.752a2.4 2.4 0 0 1 .521.934.95.95 0 0 1-.057.777.5.5 0 0 1-.356.238",
    "data-name": "Path 1041"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#058e37",
    d: "M17.087 45.084a.54.54 0 0 1-.382.136.58.58 0 0 1-.423-.423 1.9 1.9 0 0 1-.066-.9c2.077-12.487 8.712-12.611 8.776-12.611a.4.4 0 0 1 .262.1.7.7 0 0 1 .2.28 1.4 1.4 0 0 1 .1.419 2.2 2.2 0 0 1-.011.494 2.4 2.4 0 0 1-.121.494 1.9 1.9 0 0 1-.212.419 1.1 1.1 0 0 1-.271.28.5.5 0 0 1-.288.1c-.219.005-5.343.154-7.015 10.175a2.3 2.3 0 0 1-.209.616 1.3 1.3 0 0 1-.336.425",
    "data-name": "Path 1042"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M25.559 59.96c3.569 0 6.463-4.352 6.463-9.721s-2.894-9.721-6.463-9.721-6.463 4.352-6.463 9.721 2.894 9.721 6.463 9.721",
    "data-name": "Path 1043"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242929",
    d: "M30.854 47.137c.421 2.664.512 7.63-3.579 11.043a3.24 3.24 0 0 0 2.531-.837 6.24 6.24 0 0 0 1.774-2.841 9.6 9.6 0 0 0 .4-3.851 8.3 8.3 0 0 0-1.121-3.514",
    "data-name": "Path 1044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M27.338 49.332c.921 0 1.668-1.123 1.668-2.509s-.747-2.508-1.668-2.508-1.668 1.123-1.668 2.508.747 2.509 1.668 2.509",
    "data-name": "Path 1045"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 530"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#oinqtip_svg__b)",
    "data-name": "Group 529",
    transform: "translate(93.457 24.188)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#oinqtip_svg__c)",
    d: "M0 0h36.497v6.488H0z",
    "data-name": "Rectangle 320",
    transform: "translate(0 -.782)"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 532"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#oinqtip_svg__a)",
    "data-name": "Group 531",
    transform: "translate(52.029 12.566)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3b9f60",
    d: "M45.862 17.283s16.907-4.579 25.456-5.316 2.179-.062 2.179-.062-20.9 3.782-23.58 5.871Z",
    "data-name": "Path 1048"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b9f60",
    d: "M37.937 16.971s16.907-4.355 25.456-5.057 2.179-.058 2.179-.058-20.9 3.6-23.58 5.584Z",
    "data-name": "Path 1049"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M39.421 58.399c5.764 0 10.436-6.443 10.436-14.389s-4.673-14.39-10.436-14.39-10.436 6.443-10.436 14.39 4.673 14.389 10.436 14.389",
    "data-name": "Path 1050"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M43.09 46.677c2.027 0 3.67-2.266 3.67-5.06s-1.643-5.059-3.67-5.059-3.67 2.265-3.67 5.059 1.643 5.06 3.67 5.06",
    "data-name": "Path 1052"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b9f60",
    d: "M14.669 57.854S2.936 63.303.349 76.277c-1.87 9.064 3.8 20.6 16.32 16.222s19.841-5.694 27.4-5.274 17.67-3.335 18.325-9.881-1.628-16.208-11.055-21.06-22.452-6.271-36.67 1.57",
    "data-name": "Path 1053"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4db96e",
    d: "M2.979 80.857s.921 10.738 11.023 9.334 15.208-5.831 32.033-6.164 15.591-11.32 11.09-18.99-17.459-12.446-30.249-9.808S2.716 66.593 2.979 80.857",
    "data-name": "Path 1054"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b9f60",
    d: "M17.524 76.468c.332 2.394-1.073 4.57-3.142 4.855s-4.006-1.423-4.341-3.817 1.073-4.574 3.137-4.858 4.013 1.422 4.346 3.82",
    "data-name": "Path 1055"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242929",
    d: "M18.967 77.476c.332 2.394-1.073 4.57-3.138 4.858s-4.009-1.422-4.342-3.82 1.073-4.57 3.137-4.858 4.01 1.426 4.342 3.82",
    "data-name": "Path 1056"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b9f60",
    d: "M50.16 70.455c.333 2.4-1.091 4.577-3.138 4.858s-4.009-1.422-4.341-3.817 1.069-4.573 3.138-4.858 4.009 1.422 4.341 3.817",
    "data-name": "Path 1057"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242929",
    d: "M51.606 71.466c.332 2.394-1.073 4.57-3.141 4.859s-4.01-1.422-4.342-3.82 1.073-4.57 3.137-4.858 4.007 1.411 4.346 3.82",
    "data-name": "Path 1058"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a6d7b7",
    d: "M40.488 55.905s-9.567-1.633-12.669 1.645c-.583 1.49 4.049 4.188 9.616 3.224s6.862-4.851 3.054-4.869",
    "data-name": "Path 1059"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4db96e",
    d: "M91.226 94.762s-14.008-5.363-18.553-10.051c0 0-4.961-1.978-4.994 3.1-4.921 1.8-2.59 6.486.7 10.452s25.354 20.724 32.182 19.686 7.345-14.542 7.345-14.542-.192-3.4-16.679-8.642",
    "data-name": "Path 1060"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3b9f60",
    d: "M91.226 94.762s-14.008-5.363-18.553-10.051c0 0-4.961-1.978-4.994 3.1-4.921 1.8-2.59 6.486.7 10.452a27 27 0 0 0 2.81 2.7c2.126-4.494 5.271-7.74 9.82-5.879 5.489 2.193 6.624 10.565 6.4 17.638 5.364 3.264 10.449 5.642 13.15 5.229 6.828-1.038 7.345-14.542 7.345-14.542s-.192-3.4-16.679-8.642",
    "data-name": "Path 1061"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#242929",
    d: "M71.803 101.485a32 32 0 0 1-3.424-3.226c-3.285-3.966-5.619-8.654-.7-10.451.033-5.075 4.994-3.1 4.994-3.1a29.4 29.4 0 0 0 6.6 4.559 23.75 23.75 0 0 0-7.468 12.215",
    "data-name": "Path 1062"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#a6d7b7",
    d: "M74.868 98.779s-1.662 1.461-1.179 2.748 7.3 6.623 9.178 6.87-.293-4.723-2.81-7.251-4.06-3-5.189-2.367",
    "data-name": "Path 1063"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4b5a6b",
    d: "M72.559 85.653a3.7 3.7 0 0 0-2.629-.594c-1.192.363-1.3 2.061-.287 3.676-1.4-.393-2.643 1.151-1.838 3.756s4 3.155 6.273.564 3.372-4.081 1.931-5.041-3.451-2.361-3.451-2.361",
    "data-name": "Path 1064"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7e8390",
    d: "M73.085 86.321s-1.361-1.246-2.46-1.1-1.149 1.923.668 2.588 2.951-.507 1.792-1.493",
    "data-name": "Path 1065"
  }))))))));
};
export default SvgOinqtip;